import React, { createContext, useContext, useState } from 'react'

const SearchContext = createContext(null)

export const SearchProvider = ({ children }) => {
  const [location, setLocation] = useState('')
  const [near,     setNear]     = useState('')
  const [gender,   setGender]   = useState('')
  const [price,    setPrice]    = useState('')
  const [sharing,  setSharing]  = useState('')
  
  // Add these new states for search results
  const [searchResults, setSearchResults] = useState([])
  const [nearbyPincodes, setNearbyPincodes] = useState([])
  const [searchCoordinates, setSearchCoordinates] = useState(null)
  const [isSearching, setIsSearching] = useState(false)

  const clearAll = () => {
    setLocation('')
    setNear('')
    setGender('')
    setPrice('')
    setSharing('')
    setSearchResults([])
    setNearbyPincodes([])
    setSearchCoordinates(null)
    setIsSearching(false)
  }

  return (
    <SearchContext.Provider value={{
      location, setLocation,
      near,     setNear,
      gender,   setGender,
      price,    setPrice,
      sharing,  setSharing,
      clearAll,
      // Add these to the provider
      searchResults, setSearchResults,
      nearbyPincodes, setNearbyPincodes,
      searchCoordinates, setSearchCoordinates,
      isSearching, setIsSearching,
    }}>
      {children}
    </SearchContext.Provider>
  )
}

export const useSearch = () => {
  const ctx = useContext(SearchContext)
  if (!ctx) throw new Error('useSearch must be used inside <SearchProvider>')
  return ctx
}